
import React from 'react'
import sessionStore from '../session/SessionStore'
import {UserOrLoading} from "../users/components/UserOrLoading";

function getUser() {
  return sessionStore.user || {};
}

function formatNotification(notification) {
  // if (typeof getUser() === "undefined") {
  //   console.log("Can't find a user, aborting....")
  //   return {}
  // }q
  switch(notification.eventName) {
    case "TaskAssigned":
      const assignedTo = notification.payload.assignee.id === getUser().userId ? "you" : <UserOrLoading userId={notification.triggeredBy.id} justName={true} displayUsername={false}/>;

      return {
        link: "/#/workflow2/view-task/" + notification.payload.prefixedFriendlyId,
        detail: notification.triggeredBy ?
          <div>
            <span className="triggered-by"><UserOrLoading userId={notification.triggeredBy.id} justName={true} displayUsername={false}/></span> assigned
            a task to {assignedTo} <span className="task-name">({notification.payload.taskName})</span>
          </div>
          : <div>A task was generated for you ({notification.payload.taskName})</div>
      }
    case "TaskEdited":
      return {
        link: "/#/workflow2/view-task/" + notification.payload.prefixedFriendlyId,
        detail: notification.triggeredBy ? <div>
          <span className="triggered-by"><UserOrLoading userId={notification.triggeredBy.id} justName={true} displayUsername={false}/></span> updated a
          task <span className="task-name">({notification.payload.taskName})</span>
        </div> : <div>A task was updated ({notification.payload.taskName})</div>
      }
    case "TaskComment":
      return {
        link: "/#/workflow2/view-task/" + notification.payload.prefixedFriendlyId,
        detail: <div>
          <span className="triggered-by"><UserOrLoading userId={notification.triggeredBy.id} justName={true} displayUsername={false}/></span> commented
          on <span className="task-name">({notification.payload.taskName})</span> <span className="task-comment">{notification.payload.comment}</span>
        </div>
      }

  }
}

export default formatNotification

